import { compose } from "redux";
import { browserHistory } from "react-router";

import moment from "moment";
import Link from "../../../shared/ui/Link.Component";

import AuthTimer from "../../../auth/AuthTimer.Container";
import amlClaims, {
  allClaims,
  allClaimsOtherThanAml,
  amlWithDev,
} from "../../../shared/ClaimLists/Claim.Aml.All.List";

// markup
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

// custom markup
import RetractableSidebar, { activeStyle } from "./Retractable.Sidebar";
import IconWithIndicator from "../../home/components/Icon.With.Indicator";

//reloansys
import ReloansysBar from "../../../reloansys.component/Reloansys.Bar";

// icons
import HomeIcon from "@material-ui/icons/Home";
import TransactionsIcon from "@material-ui/icons/CompareArrows";
import LogOutIcon from "@material-ui/icons/PowerSettingsNew";
import ReportsIcon from "@material-ui/icons/Assignment";
import SettingsIcon from "@material-ui/icons/Settings";
import StatisticsIcon from "@material-ui/icons/TrendingUp";
import NewLoansIcon from "@material-ui/icons/AddBox";
import RegPaymentIcon from "@material-ui/icons/Create";
import SvgIcon from "@material-ui/core/SvgIcon";

import Notifications from "../../../shared/notifications/containers/Notifications.Container";

import { getCookie } from "../../../utilities/browser.tools";
import states from "../../../routes.states";

import { restRepaymentConnector } from "../../../services/loan/restRepayments/connector";
import { homeConnector } from "../../../services/home/connector";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";

import "./Home.scss";

const HomeComponent = (props) => {
  const logout = () => {
    props.logout();
  };

  const setAutogiroCookie = () => {
    let d = new Date();
    d.setTime(d.getTime() + 10000 * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie =
      "AutogiroReminder=" +
      moment(new Date()).format("YYYY-MM-DD") +
      ";" +
      expires +
      ";path=/";
  };

  const getFinanceIcon = () => {
    /// the euro icon
    return (
      <SvgIcon>
        <path d="M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </SvgIcon>
    );
  };

  const doFilterOnEnterClick = (e) => {
    if (e.key === "Enter") {
      browserHistory.push(
        states["userOverview"].url + "/query/" + props.users.currentFilter,
      );
    }
  };

  let headerFooterStyle = {
    display: "block",
    boxShadow:
      "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
    flex: "none",
    backgroundColor: "#565656",
    padding: "15px",
    color: "#fff",
  };

  let wrapperStyle = {
    display: "flex",
    minHeight: "100%",
    width: "100%",
    flexDirection: "column",
  };

  let headerStyle = Object.assign({}, headerFooterStyle, {
    textAlign: "right",
  });
  let transactionsDataLength =
    props.transactions &&
    props.transactions.data &&
    props.transactions.data.length
      ? props.transactions.data.length
      : 0;

  let transactionsIcon = (
    <IconWithIndicator
      icon={<TransactionsIcon />}
      displayIndicator={transactionsDataLength}
      indicator={transactionsDataLength}
    />
  );

  let AutogiroReminder;
  if (
    new Date().getHours() >= 16 &&
    getCookie("AutogiroReminder") !== moment(new Date()).format("YYYY-MM-DD")
  ) {
    AutogiroReminder = (
      <div className="blick-reminder autogiro-reminder">
        The clock is after 16:00, please UPLOAD ad hoc file to bank and CONFIRM
        all InProgress requests <Link toState={"autogiro"}>Here</Link>
        <br />
        <Button
          variant="contained"
          color="primary"
          style={{ float: "right" }}
          onClick={setAutogiroCookie}
        >
          It&apos;s done!
        </Button>
      </div>
    );
  }

  let financingsLen = props.financings ? props.financings.length : 0;
  let financings = (
    <IconWithIndicator
      icon={getFinanceIcon()}
      displayIndicator={financingsLen}
      indicator={financingsLen}
    />
  );

  return (
    <div style={wrapperStyle}>
      <ReloansysBar />
      <Notifications />
      <ClaimsWrapper claimAuth={allClaims}>
        <header style={headerStyle}>
          {AutogiroReminder}
          <TextField
            size="small"
            variant="outlined"
            id="userSearch"
            className="search-input"
            label={"User search"}
            onKeyDown={doFilterOnEnterClick}
            value={props.users.currentFilter}
            onChange={props.changeUserFilter}
          />
          <Link
            toState={"userOverview"}
            parameters={["query", props.users.currentFilter]}
          >
            <Button variant="contained">Search</Button>
          </Link>
        </header>
      </ClaimsWrapper>
      <div
        style={{
          display: "flex",
          position: "relative",
          flex: 1,
          whiteSpace: "nowrap",
        }}
      >
        <RetractableSidebar storageKey="home" zIndex="11">
          <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
            <List>
              <Link
                activeClassName={"selected"}
                activeStyle={activeStyle}
                toState={"dashboard"}
              >
                <ListItem button id="dashboardItem">
                  <ListItemIcon>
                    <HomeIcon />
                  </ListItemIcon>
                  <ListItemText primary="Dashboard" />
                </ListItem>
              </Link>
            </List>
          </ClaimsWrapper>
          <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
            <List>
              <Link
                activeClassName={"selected"}
                activeStyle={activeStyle}
                toState={"newLoans"}
              >
                <ListItem button id="newLoansItem">
                  <ListItemIcon>
                    <NewLoansIcon />
                  </ListItemIcon>
                  <ListItemText primary="Loanstep" />
                </ListItem>
              </Link>
              {/**/}
              <Link activeClassName={"selected"} toState={"savelendStuff"}>
                <ListItem button>
                  <ListItemIcon>{financings}</ListItemIcon>
                  <ListItemText primary="Savelend" />
                </ListItem>
              </Link>
              {/**/}
              <Link activeClassName={"selected"} toState={"mpl"}>
                <ListItem button>
                  <ListItemIcon>
                    <NewLoansIcon />
                  </ListItemIcon>
                  <ListItemText primary="New MPLs" />
                </ListItem>
              </Link>
              <Link activeClassName={"selected"} toState={"accounting"}>
                <ListItem id="regPayment" button>
                  <ListItemIcon>
                    <RegPaymentIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reg. Payment" />
                </ListItem>
              </Link>
            </List>
            <List>
              <Link activeClassName={"selected"} toState={"credits"}>
                <ListItem button>
                  <ListItemIcon>{financings}</ListItemIcon>
                  <ListItemText primary="Credits" />
                </ListItem>
              </Link>
              <Link activeClassName={"selected"} toState={"transactions"}>
                <ListItem button>
                  <ListItemIcon>{transactionsIcon}</ListItemIcon>
                  <ListItemText primary="Transactions" />
                </ListItem>
              </Link>
            </List>
            <List>
              <Link activeClassName={"selected"} toState={"terminatedSale"}>
                <ListItem button>
                  <ListItemIcon>{financings}</ListItemIcon>
                  <ListItemText primary="Terminated Loans (Sale)" />
                </ListItem>
              </Link>
              <Link
                activeClassName={"selected"}
                toState={"terminatedCollection"}
              >
                <ListItem button>
                  <ListItemIcon>{financings}</ListItemIcon>
                  <ListItemText primary="Loans To Collection" />
                </ListItem>
              </Link>
              <Link activeClassName={"selected"} toState={"sold"}>
                <ListItem button>
                  <ListItemIcon>{transactionsIcon}</ListItemIcon>
                  <ListItemText primary="Sold Loans" />
                </ListItem>
              </Link>
            </List>
          </ClaimsWrapper>
          <List>
            <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
              <Link activeClassName={"selected"} toState={"statistics"}>
                <ListItem button>
                  <ListItemIcon>
                    <StatisticsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Statistics" />
                </ListItem>
              </Link>
              <Link activeClassName={"selected"} toState={"reports"}>
                <ListItem button>
                  <ListItemIcon>
                    <ReportsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reports" />
                </ListItem>
              </Link>
            </ClaimsWrapper>
            <ClaimsWrapper claimAuth={amlClaims}>
              <Link activeClassName={"selected"} toState={"aml"}>
                <ListItem button>
                  <ListItemIcon>
                    <ReportsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Aml" />
                </ListItem>
              </Link>
            </ClaimsWrapper>
            <ClaimsWrapper claimAuth={amlWithDev}>
              <Link activeClassName={"selected"} toState={"twoStepAuth"}>
                <ListItem button>
                  <ListItemIcon>
                    <ReportsIcon />
                  </ListItemIcon>
                  <ListItemText primary="2 Step Authentication" />
                </ListItem>
              </Link>
            </ClaimsWrapper>
          </List>
          <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
            <List>
              <Link activeClassName={"selected"} toState={"menuSettings"}>
                <ListItem button>
                  <ListItemIcon>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Settings" />
                </ListItem>
              </Link>
            </List>
          </ClaimsWrapper>
          <Divider />
          <List>
            <ListItem button onClick={logout}>
              <ListItemIcon>
                <LogOutIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </RetractableSidebar>
        <div
          style={{
            width: "100%",
            boxSizing: "border-box",
            overflow: "auto",
            backgroundColor: "#f9f9f9",
          }}
        >
          {props.children}
        </div>
      </div>
      <footer style={headerFooterStyle}>
        <AuthTimer />
      </footer>
    </div>
  );
};

export default compose(restRepaymentConnector, homeConnector)(HomeComponent);
